/**
 * FullPageLoader - Full-screen loading component for authentication and page transitions
 *
 * Wrapper around LoadingSpinner specifically designed for full-page loading states,
 * primarily used during authentication verification and protected route checks.
 *
 * Features:
 * - Full-screen overlay with centered spinner
 * - Customizable loading message
 * - Consistent with app's loading UX
 * - Accessible with ARIA attributes
 *
 * @module components/common/FullPageLoader
 *
 * @example
 * import { FullPageLoader } from '@/components/common/FullPageLoader';
 *
 * // Basic usage (default message: "Verificando sesión...")
 * <FullPageLoader />
 *
 * // Custom message
 * <FullPageLoader message="Cargando..." />
 */

import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from './LoadingSpinner';

/**
 * Full-page loader component for auth and page transitions
 *
 * @param {Object} props
 * @param {string} [props.message='Verificando sesión...'] - Loading message to display
 * @returns {JSX.Element}
 */
export function FullPageLoader({ message = 'Verificando sesión...' }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-raios-secondary">
      <LoadingSpinner
        size="large"
        message={message}
        aria_label={message}
      />
    </div>
  );
}

FullPageLoader.propTypes = {
  message: PropTypes.string,
};

// Default export for backward compatibility
export default FullPageLoader;
